import "./shoppable-image-products";

class MainArticle extends HTMLElement {
  constructor() {
    super();
    const content = this.querySelector("[data-content]");
    const shortcodeRegex = /\[shoppable-image-products=(?<handles>[^\]]+)\]/gm;

    content.innerHTML = content.innerHTML.replace(
      shortcodeRegex,
      (_, handles) => {
        return `<span data-shoppable-marker="${handles}"></span>`;
      },
    );

    const unwrappedImages = [];

    content.querySelectorAll("* > img:only-child").forEach((img) => {
      const wrapper = img.parentElement;
      if (wrapper === content) return;

      wrapper.replaceWith(img);
      img.removeAttribute("style");
      unwrappedImages.push(img);
    });

    // Runs before the shoppable tags are inserted, while the blockquote is still
    // the image's next sibling.
    unwrappedImages.forEach((img) => {
      const next = img.nextElementSibling;
      if (!next || next.tagName !== "BLOCKQUOTE") return;

      next.textContent = next.textContent.replace(/\s+/g, " ").trim();
    });

    const markers = content.querySelectorAll("[data-shoppable-marker]");
    const imageAssignments = new Map();

    markers.forEach((marker) => {
      const handles = marker.getAttribute("data-shoppable-marker");

      let currentElement = marker;
      let targetImage = null;

      while (currentElement && currentElement !== content && !targetImage) {
        let previousSibling = currentElement.previousElementSibling;

        while (previousSibling) {
          if (previousSibling.tagName === "IMG") {
            targetImage = previousSibling;
            break;
          }
          const nestedImg = previousSibling.querySelector("img");
          if (nestedImg) {
            targetImage = nestedImg;
            break;
          }
          previousSibling = previousSibling.previousElementSibling;
        }

        if (!targetImage) {
          currentElement = currentElement.parentElement;
        }
      }

      // Subsequent shortcodes hitting the same image will overwrite this key (Last wins).
      if (targetImage) {
        imageAssignments.set(targetImage, handles);
      }
    });

    imageAssignments.forEach((handles, imgElement) => {
      const shoppableTag = document.createElement("shoppable-image-products");
      shoppableTag.classList.add("visually-hidden");
      shoppableTag.setAttribute("handles", handles);
      imgElement.insertAdjacentElement("afterend", shoppableTag);
    });

    markers.forEach((marker) => marker.remove());

    content.querySelectorAll("p, span, blockquote").forEach((el) => {
      if (el.innerHTML.trim() === "" || el.innerHTML.trim() === "<br>") {
        el.remove();
      }
    });
  }
}

if (!customElements.get("main-article")) {
  customElements.define("main-article", MainArticle);
}
